// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
export const ComponentInstagramWithContentFragmentDoc = gql`
    fragment componentInstagramWithContent on ComponentInstagramWithContent {
  instagramWithContentWidth: width
  useImage
  instagramEmbedCode
  instagramUsername
  instagramLink
  instagramImage {
    ...imageLarge
  }
  instagramPosition
  optionalContent: content {
    ...contentComponentItem
  }
}
    ${ImageLargeFragmentDoc}
${ContentComponentItemFragmentDoc}`;